import React from 'react';

import { Container } from '@mui/material';

import { angularizeWithProviders } from '../../../../../shared/providers';
import { PageTitle } from '../../../../../shared/components/ui-components';
import { VideoList } from './VideoList/VideoList';
import { useVideoTab } from './hooks/useVideoTab';
import {
  LbTabPanel,
  LbTabs,
  LbUnderlineTabsList,
  TabsConfig,
} from '../../../../../shared/components/tabs';

const NgzVideosTab = () => {
  const { videoData } = useVideoTab();

  const tabsConfig: TabsConfig[] = videoData.map((videoCategory, index) => ({
    label: videoCategory.name,
    hide: !videoCategory.videos.length,
    value: index,
    panel: <VideoList videos={videoCategory.videos} />,
  }));

  return (
    <Container>
      <LbTabs defaultValue={0}>
        <PageTitle
          title="Videos"
          tabs={<LbUnderlineTabsList tabsConfig={tabsConfig} />}
        />
        <LbTabPanel tabsConfig={tabsConfig} />
      </LbTabs>
    </Container>
  );
};

angularizeWithProviders(NgzVideosTab, 'ngzVideosTab', {});

export { NgzVideosTab };
